// extracted by mini-css-extract-plugin
export var bottombar = "PanelWrapperFullWidth-module--bottombar--54030";
export var container = "PanelWrapperFullWidth-module--container--c475d";
export var content = "PanelWrapperFullWidth-module--content--69a0a";
export var topbar = "PanelWrapperFullWidth-module--topbar--f52b0";